export default {
  TITLE_CONT: '头部配置'
}
